import { render, staticRenderFns } from "./ProxyVoteTable.vue?vue&type=template&id=4381dee1&scoped=true&"
import script from "./ProxyVoteTable.vue?vue&type=script&lang=ts&"
export * from "./ProxyVoteTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyVoteTable.vue?vue&type=style&index=0&id=4381dee1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381dee1",
  null
  
)

export default component.exports